import { mapGetters } from 'vuex'

const users = {
  computed: {
    ...mapGetters({
      user_data: 'userData',
      lang: 'getLanguage',
      get_data: 'getData'
    })
  },
  methods: {
    getHistory (type) {
      return (this.get_global.defaults.options.users.history && typeof this.get_global.defaults.options.users.history[type - 1] !== 'undefined' ? this.get_global.defaults.options.users.history[type - 1] : {})
    },

    saveUser (user) {
      // this.$refs.SaveForm.resetValidation()
      this.validate = {
        login_exist: false,
        match_error: false,
        login_exist_msg: '',
        match_error_msg: ''
      }
      if (this.$refs.SaveForm.validate()) {
        var loginValid = !(this.get_data.users.some((e) => e.login === user.login && e.id !== user.id))
        var passValid = (user.pass && user.pass_confirm ? (user.pass.length || user.pass_confirm.length ? (user.pass === user.pass_confirm) || false : true) : (this.id > 0 || false))
        if (!loginValid) {
          this.validate.login_exist = true
          this.validate.login_exist_msg = this.lang.users.new.validate.error.login_exist
        }
        if (!passValid) {
          this.validate.match_error = true
          this.match_error_msg = this.lang.users.new.validate.error.pass_match
        }
        if (passValid && loginValid) this.$store.dispatch('saveData', { page: 8, data: user, item: this.id })
      }
    },

    deleteUser (user) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.users.dialog.deleteConfirm} ${user.name}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveAction', { page: 8, type: 1, item: user.id })
      })
    }
  }
}
export default users
